/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Import_Form_LabelInputs */



/**
* | output |
* | --- |
* | "Translation import form" |
*
* @param {Translation_Import_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_import_form_label = /** @type {((inputs?: Translation_Import_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Import_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Formulaire d'importation de traduction")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übersetzungsimportformular")
	if (locale === "it") return /** @type {LocalizedString} */ ("modulo di importazione della traduzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Форма импорта перевода")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formulario de importación de traducción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("翻译导入表单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("翻訳インポートフォーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुवाद आयात प्रपत्र")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formulário de importação de tradução")
	return /** @type {LocalizedString} */ ("Translation import form")
});